import { createContext } from 'react';

export const CarouselContext = createContext({});

export { default as CarouselControls } from './CarouselControls';
export { default as CarouselItem } from './CarouselItem';
export { default as CarouselWrapper } from './CarouselWrapper';
export { default as CarouselPagination } from './CarouselPagination';
